import React from 'react';

const PushNotificationIcon = ({fill}) => {
    return (
        <svg width="20" height="18" viewBox="0 0 256 256" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path d="M174.55,144.5L174.55,144.5c-1.4-4-5-6.5-9.2-6.5H159V23c0-11.708-9.292-21-21-21H25C12.57,2,2,12.57,2,25v183
	c0,11.9,10.95,22,22.75,22l114.213,0c1.207,0,2.27,0.984,2.18,2.188c-0.095,1.266-1.153,1.812-2.393,1.812h-45.5L128,254h80
	L174.55,144.5z M82.05,220.2c-3.199,0-5.599-2.399-5.6-5.598c-0.001-3.045,2.557-5.602,5.602-5.602
	c3.199,0.001,5.598,2.401,5.598,5.6C87.55,217.8,85.25,220.2,82.05,220.2z M144,138h-19.65c-5.3,0-9.8,4.7-9.8,10l0,0
	c0,5.3,4.5,10,9.8,10h19.8v42H18V31h126V138z M43.046,48.087c4.825,0,8.736,3.911,8.736,8.736s-3.911,8.736-8.736,8.736
	s-8.736-3.911-8.736-8.736S38.221,48.087,43.046,48.087z M56.665,50.112h70.03v13.381h-70.03V50.112z M43.046,77.352
	c4.825,0,8.736,3.911,8.736,8.736c0,4.825-3.911,8.736-8.736,8.736s-8.736-3.911-8.736-8.736
	C34.31,81.263,38.221,77.352,43.046,77.352z M56.665,79.377h70.03v13.381h-70.03V79.377z M43.046,106.616
	c4.825,0,8.736,3.911,8.736,8.736c0,4.825-3.911,8.736-8.736,8.736s-8.736-3.911-8.736-8.736
	C34.31,110.527,38.221,106.616,43.046,106.616z M56.665,108.681h70.03v13.381h-70.03V108.681z"/>
        </svg>
    );
};

export default PushNotificationIcon;